export const handleScrollIntoView = (id, block = 'start') => {
    if (id) {
        const scrollTimer = setTimeout(() => {
            let target = document.getElementById(id)
            if (target) {
                target.scrollIntoView({
                    block: block,
                    behavior: 'smooth',
                })
            }
        }, 500)
        return () => clearTimeout(scrollTimer)
    }
}
